export const habaCommon = {
  pageHero: {
    sideTitle: 'On this page',
  },
  breadcrumbs: {
    home: 'Start',
    shop: 'Shop',
  },
  habaSearch: {
    home: 'Home',
    productsAndShop: 'Products & Shop',
    placeholder: 'Search',
    searchSuggestions: 'Search Suggestions',
    brandSuggestions: 'Brand',
    categorySuggestions: 'Category',
    productSuggestions: 'Product',
    noSuggestions: 'No results.',
    noProductSuggestions: 'There are no product matches for your search.',
    viewAll: 'View all ({{ number }})',
    contentPages: 'Content pages',
    servicesAndBenefits: 'Services & Benefits',
    faq: 'Frequently asked Questions',
    more: 'More',
    filter: 'Filter',
    filterButton: 'Filters',
    filterAndSort: 'Filters & Sort',
    categories: 'Further categories',
    filters: {
      age: 'Age',
      color: 'Color',
      brand: 'Brand',
      categories: 'More Categories',
      campaignTags: 'Campaign',
      newArrivals: 'new Arrivals',
      showNewArrivals: 'New in Shop',
      more: 'More',
      price: 'Price',
      gender: 'Gender',
      size: 'Size',
      suitableFor: 'Suitable for',
      ageGroups: 'Age',
      ageRange: 'Age',
      productFunctions: 'Function',
      productFeatures: 'Feature',
      productSeries: 'Product Series',
      materials: 'Material',
      sort: 'Sort',
      sortedBy: 'Sorted by',
      sortSub: {
        mostPopular: 'Relevant',
        new: 'Novelties',
        priceAsc: 'Price (lowest first)',
        priceDesc: 'Price (highest first)',
        nameAsc: 'Name (descending)',
        nameDesc: 'Name (Ascending)',
      },
      sortBy: 'Sort by',
      reviews: 'Reviews',
      show: 'Show',
      filter: 'Filter',
      salesFilter: 'Only special offers',
      specialPrice: 'special offers',
      resetAll: 'Reset all',
      reset: 'Reset',
      showMore: '+ Show more',
      showLess: '- Show less',
      labels: {
        Babys: 'Baby (0 - 18 months)',
        Minis: 'Minis (1.5 - 5 years)',
        Kids: 'Kids (5 - 7 years)',
        Juniors: 'Juniors (above 8 years)',
        'keine Angabe': 'not specified',
        Junge: 'Boys',
        Madchen: 'Girls',
        unisex: 'Unisex',
      },
    },
    noResults: {
      titleFirstPart: 'Your search with ',
      titleSecondPart: ' did not lead to any results.',
      subtitle: 'Did you maybe make a typo? Try again with a more general search term.',
      inspiration: 'Or let yourself be further inspired here!',
    },
    recommendations: {
      similarProducts: 'Similar Products',
      matchingProducts: 'Matching Products',
    },
  },
  habaNavigation: {
    showAll: 'Alles anzeigen',
    more: 'Mehr',
    back: 'zurück',
    allProducts: 'Alle Produkte',
    topLinks: {
      directOrders: 'Direct Orders',
      contact: 'contact',
    },
    countrySelection: 'Country Selection',
    germany: 'Deutschland',
    austria: 'Österreich',
  },
  habaHttpHandlers: {
    code: {
      alreadyRedeemed: 'The voucher has already been added.',
      maxApplied: 'A maximum of 3 vouchers can be redeemed per order.',
      expired: 'This code is expired.',
      unknownException: 'The voucher number is not valid.',
      invalidCodeProvided: 'This code is invalid.',
      giftcardCommunicationError: 'Communication error with S/4!',
      giftcardErrorS4NotAvailable:
        'Unfortunately, discount codes cannot currently be redeemed due to technical reasons. Please contact our customer service.',
      giftcardRedemptionNotAllowed: "Vouchers cannot be redeemed with this payment method.",
      giftcardInvalidBusinessModel: 'Invalid business model {{ additionalMessage }}',
      giftcardInvalidBrand: 'Invalid brand {{ additionalMessage }}',
      giftcardInvalidCurrency: 'Invalid currency {{ additionalMessage }}',
      giftcardAmount: 'The amount left on the Gift Card is 0',
      giftcardInvalid: 'The Gift card is not valid - it expired on {{ additionalMessage }}',
      purchaseGiftcards: 'This payment method cannot be used to purchase vouchers',
      badRequest:
        'Unfortunately, the change is not possible, please enter a different email address.',
      billingAddressNotSet: 'Please enter your billing address',
      deliveryAddressNotSet: 'Please enter your shipping address',
    },
    notAvailable: 'Page not available',
    registration: {
      success: 'Your account has been activated. You can login now.',
      tokenExpired: 'Token expired',
      invalidToken: 'Invalid token',
      notSpecific: 'An unexpected error has occurred',
      customerNotFound: 'Customer not found',
    },
    featureNotAvailable:
      'This feature is currently unavailable for technical reasons. Please contact our customer service.',
  },
  habaAuthentication: {
    success: 'Authentication successful',
    ociAuthenticationFailed:
      'An error occurred while trying to create the session. Please try again.',
  },
  habaFooter: {
    contact: {
      retour: {
        headline: 'Returns & Cancellation Form',
        description: 'Would you like to cancel an order or return an item?',
        button: 'Cancel order',
      },
    },
    info: {
      infoService: 'InfoService',
      schedule: 'Monday - Friday 08 - 18 Uhr.',
      infoServiceTelephone: {
        DE: '0800-8827773',
        AT: '0800-8809407',
      },
      infoServiceEmail: 'kontakt@wehrfritz.com',
      contactForm: 'Contact Form',
      orderService: 'OrderService',
      orderServiceTelephone: {
        DE: '0800-8827773',
        AT: '0800-8809400',
      },
      orderServiceEmail: 'bestellungen@wehrfritz.com',
    },
    copyright:
      '© {{year}} - Habermaass GmbH & Co. KG - belongs to the Habermaass family of companies',
    shop: {
      catalog: {
        headline: 'Our catalog',
        text1: 'request catalogs',
        text2: 'Browse online',
      },
      payment: {
        headline: 'Our payment methods',
      },
      secureShopping: {
        headline: 'Secure shopping',
        text1: 'Secure shopping with SSL encryption',
      },
      newsletter: {
        headline: 'Newsletter',
        text1: 'Register',
        text2: 'Get informed about all the novelties in your industry and ideas from the field!',
      },
    },
    orderInformation: {
      heading: 'Ordering Information',
      text1: 'No minimum order value',
      text2: 'Please note that the items in your shopping cart are not reserved ',
    },
    hints: {
      heading: 'Hints',
      text1: 'All prices in EUR, incl. VAT. ',
      text2: 'plus shipping and service costs ',
    },
  },
  habaEmptyCategory: {
    websiteTitle: 'All products',
    seoTitle: 'Online Shop Wehrfritz | Discover innovative premium products',
    seoDescription:
      'Wehrfritz stands for individual solutions that add value ➽ Your complete supplier for nursery, kindergarten & school ➽ Discover all products!',
  },
  countdownBanner: {
    label: 'Time left:',
    days: 'Days',
    day: 'Day',
    hours: 'Hrs',
    minutes: 'Min',
    seconds: 'Sec',
    daysShort: 'D',
    hoursShort: 'H',
    minutesShort: 'M',
    secondsShort: 'S',
  },
  blogPage: {
    pageLinksQuestion: 'What topics interest you?',
  },
  postalCode: {
    label: 'Search by postal code',
    placeholder: 'Postal code',
    error: 'Please enter a valid postal code',
    button: 'Search',
    info: 'Enter your postal code to find the responsible consultant.',
    responsible: 'Responsible for {{ city }}',
    phone: 'Tel: {{ phone }}',
    contactNotFound: 'The region around {{ city }} is currently not covered. You can find the contact for the responsible specialist advice through our internal service.'
  }
};
